import _moment from 'moment';
const moment = _moment;

class FormUtils {
  static getInitialValues(data: any): any {
    if (!data || !Array.isArray(data)) {
      return {};
    }

    let initValObj = {};
    let currObj;
    for (let i = 0; i < data.length; i++) {
      currObj = data[i];
      if (currObj.group) {
        if (currObj.elements && Array.isArray(currObj.elements)) {
          for (let j = 0; j < currObj.elements.length; j++) {
            if (currObj.elements[j].name) {
              initValObj = {
                ...initValObj,
                [currObj.elements[j].name]: currObj.elements[j].value
              };
            }
          }
        }
      } else {
        if (currObj.name) {
          initValObj = {...initValObj, [currObj.name]: currObj.value};
        }
      }
      currObj = null;
    }

    return initValObj;
  }

  // Do not remove/rename field here, it is important for eval to work. Eval needs field in its context
  static getFieldViewStatus(field: Record<string, any>, expression: any): any {
    if (!field || !expression) {
      return false;
    }
    return !!eval(expression);
  }

  static formatDate(date: Date | undefined, format?: string): string {
    try {
      if (!date || isNaN(date.getTime())) {
        return '';
      }
      const m = moment(date);
      let formatDate = '';
      if (format) {
        formatDate = m.format(format);
      } else {
        formatDate = m.format('YYYY-MM-DD');
      }
      return formatDate;
    } catch {
      return '';
    }
  }

  static dateDifference(expiryDate: Date | undefined, format?: string): number {
    try {
      if (!expiryDate || isNaN(expiryDate.getTime())) {
        return Number.POSITIVE_INFINITY;
      }
      return moment(expiryDate).diff(moment(), 'day');
    } catch {
      return Number.POSITIVE_INFINITY;
    }
  }

  static getFieldName(field: Record<string, any>, key: string): any {
    if (!field || !key) {
      return '';
    }
    let fieldName = '';

    for (let i = 0; i < field.length; i++) {
      if (field[i].id === key) {
        fieldName = field[i].name;
        break;
      }
    }

    return fieldName;
  }
}

export default FormUtils;
